import React, { useState } from "react";
import { NavLink } from "react-router-dom";

import './style.css'
import Spacer from "../Spacer";
import Divider from "../Divider";
import { THEMES } from "src/constatnts";
import { Form } from "../form";

export const ROUTES = {
  home: '/',
  pricing: '/pricing',
  aiPoweredCyberAttackSimulation: '/ai-powered-cyber-attack-simulation',
  securityAwarenessTrainings: '/security-awareness-trainings',
  emailThreatReportButton: '/email-threat-report-button',
  intelligentThreatResponse: '/intelligent-threat-response',
  gamificationPlatform: '/gamification-platform',
  socialEngineeringPrevention: '/social-engineering-prevention',
  behavioralChange: '/behavioral-change',
  comprehensiveCybersecurity: '/comprehensive-cybersecurity',
  proactiveRiskAssessment: '/proactive-risk-assessment',
  globalWorkforceDefense: '/global-workforce-defense',
  appfraud: '/appfraud',
  achieveAndMaintainRobust: '/achieve-and-maintain-robust',
  whyCyberlift: '/why-cyberlift',
  aiPoweredPlatform: '/ai-powered-platform',
  cyberliftVsCompetitors: '/cyberlift-vs-competitors',
  aboutUs: '/about-us',
  terms: '/terms',
  newsroom: '/newsroom',
  partners: '/partners',
  careers: '/careers',
  securityCompliance: '/security-compliance',
  technologies: '/technologies',
  contacts: '/contacts',
  privacyPolicy: '/privacy-policy',
  termsOfUse: '/terms-of-use',
  dpa: '/data-processing-agreement',

}

export const NavButton = ({ fullwidth = false, children, to = '#', variant = 'light', size = 'sm', style = {}, onClick = null }) => {
  return (
    <button
      className={"row row-center "}
      style={{
        ...style,
        border: 0,
        background: variant == 'light' ? '#5E2751' : '#AE2573',
        borderRadius: 4,
        padding: (size == 'sm' || size == 'xs') ? '8px 35px' : '22px 35px',
        cursor: 'pointer',
        ...(fullwidth && { width: '100%', justifyContent: 'center' }),

      }}
      onClick={() => { onClick ? onClick() : window.open(to, '_self') }}
    ><span style={{
      fontFamily: 'Roboto',
      textTransform: 'uppercase',
      letterSpacing: (size == 'sm' || size == 'xs') ? 1 : 1.6,
      color: '#fff',
      fontSize: size == 'sm' ? 10 : size == 'xs' ? 8 : 16
    }}>{children}</span>

      {(size == 'sm' || size == 'xs') ? <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_224_20)">
          <path fillRule="evenodd" clipRule="evenodd" d="M7.46437 6.69971L5.04688 4.31041L5.79125 3.57471L8.95313 6.69971L5.79125 9.82471L5.04688 9.08901L7.46437 6.69971Z" fill={'#fff'} />
        </g>
        <defs>
          <clipPath id="clip0_224_20">
            <rect width="12.5" height="12.5" fill="white" transform="translate(0.75 0.449707)" />
          </clipPath>
        </defs>
      </svg>

        :

        <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_224_50)">
            <path fillRule="evenodd" clipRule="evenodd" d="M11.243 10L7.375 6.17712L8.56601 5L13.625 10L8.56601 15L7.375 13.8229L11.243 10Z" fill={'#fff'} />
          </g>
          <defs>
            <clipPath id="clip0_224_50">
              <rect width="20" height="20" fill="white" transform="translate(0.5)" />
            </clipPath>
          </defs>
        </svg>

      }

    </button>
  )
}




export const Navigation = ({ theme, style, isAllowed }) => {
  const [mobileMenuShown, setMobileMenuShown] = useState(false)
  const [mobileFormShown, setMobileFormShown] = useState(false)

  const handleOpenMenu = () => {
    document.body.classList.toggle('lock-scroll')
    setMobileMenuShown(!mobileMenuShown)
  }

  const handleOpenForm = () => {
    window.open('https://security.penprotect.ai/activate')
  }

  return (
    <div style={style} className={"nav row row-center " + theme}>
      <div className="container1300 row row-center">
        <div className="row row-center" style={{ width: '100%' }}>
          <NavLink to='/'>
            {isAllowed && <img src="/images/logo-ajg.png" className="nav-logo" alt="" />}
          </NavLink>

          <Spacer />

          <div className="row row-center hide mob-show">
            <NavButton onClick={handleOpenForm} variant="dark" size="xs" style={{ marginRight: 12 }}>Activate</NavButton>
          </div>
          <div onClick={handleOpenMenu} className="burger-menu-button">
            <svg width="19" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1H17.9987" stroke={theme == THEMES.light ? "#1D1D29" : "#0B1720"} strokeWidth="2" strokeLinecap="round" />
              <path d="M1 8.00049H17.9987" stroke={theme == THEMES.light ? "#1D1D29" : "#0B1720"} strokeWidth="2" strokeLinecap="round" />
              <path d="M1 15H17.9987" stroke={theme == THEMES.light ? "#1D1D29" : "#0B1720"} strokeWidth="2" strokeLinecap="round" />
            </svg>
          </div>


          <div className="row row-center mob-hide">
            <NavButton to="https://security.penprotect.ai/" style={{ marginRight: 20 }} variant="dark">Sign in</NavButton>
            <NavButton to="https://prebind.penprotect.ai/landing">Pre Bind Scan Portal</NavButton>
          </div>

          {mobileMenuShown &&
            <div className="mobile-menu" >
              <div className="row row-center">
                {isAllowed && <img src="/images/logo-ajg-2.png" width={60} alt="" />}
                <Spacer />
                <div onClick={handleOpenMenu} className="burger-menu-button">
                  <svg width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.24219 6.75391L18.7422 19.2539" stroke="#0B1720" strokeWidth="1.75" strokeLinecap="round" />
                    <path d="M6.24219 19.2461L18.7422 6.7461" stroke="#0B1720" strokeWidth="1.75" strokeLinecap="round" />
                  </svg>

                </div>
              </div>

              <Divider style={{ margin: '0px 0px 50px 0px', background: '#D8D8FF' }} />
              <NavButton to="https://security.penprotect.ai/" fullwidth size="md" style={{ width: '100%', marginBottom: 28 }} >Sign in</NavButton>
              <NavButton to="https://prebind.penprotect.ai/landing" fullwidth size="md" style={{ width: '100%', marginBottom: 28 }} variant="dark">Pre Bind Scan Portal</NavButton>


            </div>
          }
          {mobileFormShown &&
            <div className="mobile-menu" style={{ padding: '32px 18px' }}>
              <div className="row row-center">
                {isAllowed && <img src="/images/logo-ajg.png" width={140} alt="" />}
                <Spacer />
                <div onClick={handleOpenForm} className="burger-menu-button">
                  <svg width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.24219 6.75391L18.7422 19.2539" stroke="#0B1720" strokeWidth="1.75" strokeLinecap="round" />
                    <path d="M6.24219 19.2461L18.7422 6.7461" stroke="#0B1720" strokeWidth="1.75" strokeLinecap="round" />
                  </svg>

                </div>
              </div>
              <div className="column" style={{ height: 'calc(100dvh - 130px)', overflow: 'auto' }}>
                <Form onClose={handleOpenForm} />

              </div>
            </div>
          }
        </div>

      </div>
    </div>
  )
}
